module.exports = __webpack_public_path__ + "media/images/no-image/no-image-blog-1a4e744411ea7c8931f68ad0522882b8.png";